var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 3 20 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.7784 16.6001C17.9592 16.1846 18.1659 15.7174 18.3748 15.1877C18.6267 14.5526 18.885 13.8292 19.1132 13.0046C19.1864 12.7355 19.3371 12.1693 19.4814 11.3791C19.0013 10.3263 18.1724 9.01298 16.7557 7.99031C15.3692 6.98918 13.9719 6.66408 13.3906 6.5349C12.4885 6.33467 11.6704 6.28731 10.9922 6.30453C9.76498 7.44561 8.69064 8.68142 7.99092 9.53831C7.45698 10.1907 7.14049 10.6234 7.14049 10.6234C5.07363 13.4503 4.73346 14.7851 4.63873 15.7992C4.58706 16.3482 4.60643 16.8111 4.63442 17.1319C4.63442 17.1362 4.63442 17.1426 4.63442 17.147L4.42773 17.6766C4.6215 18.1007 4.83034 18.4194 4.99612 18.6454C5.65494 19.5368 6.46015 20.0492 7.6529 20.792C7.74333 20.8479 7.82945 20.9018 7.91342 20.9513C8.05982 20.6843 8.22344 20.3915 8.4043 20.075C9.3064 18.4947 9.97382 17.4785 10.3527 16.9144C10.8587 16.163 11.6402 15.0112 11.8082 15.0995C11.9137 15.1554 11.7457 15.698 11.6553 15.9865C11.4938 16.5054 11.2979 16.8671 11.2807 16.8994C10.6262 18.1115 11.2053 17.246 9.91569 19.5712C9.47648 20.3614 9.15353 20.9427 8.83705 21.4895C9.53677 21.9373 10.7188 22.5423 12.2667 22.6586C12.6694 22.6887 13.0418 22.6823 13.382 22.6543L13.6942 22.2818L13.9267 22.0062C15.3627 20.7898 16.2218 19.5863 16.7299 18.7337C17.1562 18.0211 17.4253 17.4032 17.7784 16.5979V16.6001ZM11.9869 14.7248C11.0439 14.1888 10.7963 12.8474 11.4335 11.7257C12.0708 10.6062 13.3497 10.1304 14.2927 10.6665C15.2357 11.2026 15.4833 12.5439 14.846 13.6656C14.2087 14.7851 12.9299 15.2609 11.9869 14.7248Z",
    fill: "none",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 22.4974C13.0066 22.5276 12.6406 22.5297 12.281 22.5017C11.1184 22.4135 9.95794 22.0195 8.92666 21.3585L8.78456 21.2681L8.70059 21.4145C8.43793 21.8687 8.19249 22.2757 7.90614 22.7299C7.76405 22.956 7.62625 23.1713 7.49492 23.3715L7.40234 23.5136L7.7296 23.7052C8.68337 24.1165 9.65006 24.3877 10.3778 24.4459C10.4747 24.4545 10.5629 24.4566 10.6426 24.4566C11.0366 24.4566 11.4004 24.4071 11.4177 24.405C11.5877 24.3813 11.7621 24.349 11.9344 24.3059C12.0506 24.2779 12.1561 24.2499 12.2509 24.2198L12.2961 24.2047L13.7558 22.463L13.3704 22.4953V22.4974Z",
    fill: "url(#paint1_linear_16376_57035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13615 20.896L8.00266 20.8164C7.9187 20.7669 7.83258 20.713 7.7443 20.6571C6.60537 19.9487 5.78509 19.4363 5.13058 18.5514C4.91744 18.2629 4.73228 17.9465 4.57942 17.6127L4.4201 17.2661L3.59766 19.376L3.61919 19.4342C3.67947 19.5913 3.74621 19.7507 3.81726 19.9057C4.03256 20.375 4.29522 20.8185 4.59879 21.2233C4.89806 21.6259 5.23823 21.9941 5.6107 22.3192C5.97024 22.6314 6.36424 22.9112 6.78407 23.1459L6.93693 23.2256L7.01014 23.0684C7.28787 22.4763 7.64096 21.7917 8.05864 21.0317L8.13399 20.896H8.13615Z",
    fill: "url(#paint2_linear_16376_57035)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.6315 24.2959C10.5583 24.2959 10.4787 24.2916 10.3904 24.2852C10.16 24.6426 9.89091 25.0193 9.57872 25.4047C9.32898 25.7148 9.07923 25.9946 8.83594 26.2444C8.73691 26.3197 8.60557 26.3348 8.50223 26.2832C8.38382 26.2229 8.35152 26.1045 8.34506 26.0851C7.57429 26.6535 7.0016 27.0561 6.88534 27.112C6.85735 27.1271 6.78415 27.1637 6.70018 27.1443C6.65927 27.1357 6.62913 27.1164 6.60976 27.0991C6.38585 27.2649 5.94448 27.6137 5.61723 27.7816C5.4493 27.8677 5.32012 27.9345 5.15864 27.9689C4.96272 28.012 4.91751 27.8333 4.88306 27.6546C4.81417 27.3037 4.78618 26.8817 4.77111 26.4575C4.76465 26.2702 4.76465 26.0915 4.77111 25.9214C4.54935 26.0592 4.43309 26.042 4.37065 26.014C4.13598 25.8999 4.17042 25.3444 4.20487 24.24C4.20918 24.1345 4.21349 24.0311 4.2221 23.9299L4.04125 23.8137C4.04125 23.4778 4.07354 23.073 4.17042 22.6252C4.30176 22.0138 4.51706 21.5121 4.72374 21.1246C4.38357 20.666 4.13813 20.2203 3.95943 19.835C3.80442 20.061 3.65156 20.3065 3.503 20.5756C2.94968 21.5875 2.68702 22.5563 2.55784 23.3185C2.53416 23.4541 2.62243 23.5855 2.75591 23.6156C2.69778 23.8847 2.64827 24.1754 2.61166 24.4876C2.56215 24.9031 2.54492 25.2885 2.54492 25.6416C2.54492 25.7901 2.63104 25.9236 2.76237 25.9903L2.91093 26.0635C2.8894 26.2831 2.87002 26.5071 2.8528 26.7331C2.81189 27.2735 2.73654 27.5254 2.77744 27.9259C2.80113 28.1562 2.84203 28.5007 3.03365 28.5632C3.109 28.589 3.18866 28.5632 3.24895 28.5309C3.24679 28.7117 3.2834 28.8883 3.27478 29.1014C3.26187 29.4114 3.33722 29.8334 3.38243 30.1542C3.41688 30.3975 3.68816 30.5288 3.9013 30.4061C4.38788 30.1241 4.92828 29.7452 5.4127 29.4653C5.7421 29.2758 6.05644 29.0842 6.3557 28.8926L6.42675 28.9356C6.56024 29.0153 6.72817 29.0153 6.86166 28.9335C6.9693 28.8667 7.08987 28.7892 7.21905 28.7009C7.78098 28.3113 8.14914 27.9496 8.23095 27.8677C8.47209 27.6266 8.76489 27.2972 9.05339 26.8709C9.08784 26.9032 9.15889 26.957 9.26439 26.9807C9.44524 27.0216 9.58949 26.942 9.62393 26.9204C10.0115 26.6169 10.4701 26.2013 10.92 25.648C11.3549 25.1141 11.6671 24.5909 11.891 24.1452C11.7403 24.1818 11.5745 24.2141 11.3894 24.24C11.3894 24.24 11.0169 24.2916 10.6251 24.2916L10.6315 24.2959Z",
    fill: "url(#paint3_linear_16376_57035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1436 10.6263C7.1436 10.6263 7.46009 10.1935 7.99403 9.54118C6.49555 9.47013 5.39538 9.79523 4.76025 10.045C4.30597 10.2215 3.9701 10.4067 3.76772 10.5186C2.17451 11.3992 1.26165 12.5144 0.951619 12.9192C0.684649 13.268 0.329407 13.7847 0 14.4672L4.63753 17.1348C4.60954 16.814 4.59016 16.3511 4.64183 15.8021C4.73656 14.788 5.07674 13.4532 7.1436 10.6263Z",
    fill: "url(#paint4_linear_16376_57035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.731 18.7361C16.2229 19.5887 15.3639 20.7944 13.9278 22.0086L13.6953 22.2842L18.5288 24.9991C18.9486 24.3662 19.2091 23.7978 19.3727 23.3887C19.5622 22.915 20.0531 21.5608 19.9949 19.7415C19.9885 19.5112 19.9734 19.1258 19.8938 18.6457C19.7689 17.8964 19.4352 16.6068 18.3737 15.188C18.1649 15.7155 17.9582 16.1848 17.7774 16.6003C17.4264 17.4056 17.1552 18.0235 16.7289 18.7361H16.731Z",
    fill: "url(#paint5_linear_16376_57035)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3549 4.22512C19.1138 3.78807 18.8102 3.38331 18.4506 3.0216L18.4119 2.98285L18.3581 2.97424C17.6131 2.86874 16.8768 2.88812 16.1685 3.03667C15.5355 3.17016 15.0618 3.37469 14.6829 3.54047C14.6485 3.55555 13.8131 3.92155 12.9864 4.48133C12.3232 4.9313 11.6128 5.50399 10.8807 6.18649L10.5664 6.47714L10.9948 6.46638C11.7893 6.4427 12.5838 6.5202 13.3545 6.69244C13.8798 6.8087 15.2707 7.11873 16.6594 8.12202C17.8047 8.94877 18.7047 10.0683 19.3334 11.4484L19.5465 11.9177L19.6391 11.4118C19.8329 10.3504 19.9491 9.26526 19.9814 8.18446C20.0546 5.83986 19.7037 4.86887 19.3506 4.22728L19.3549 4.22512Z",
    fill: "url(#paint6_linear_16376_57035)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8907 14.962C11.6625 14.8392 11.4041 15.0825 10.2264 16.8286C9.58915 17.7738 8.94972 18.8115 8.27153 19.9999C8.09068 20.3186 7.92705 20.6114 7.77849 20.8784C7.35866 21.6448 7.00127 22.3359 6.71922 22.9388C6.53407 23.3328 6.35322 23.7375 6.18098 24.138L6.125 24.2715L6.96466 24.7494L7.04863 24.6267C7.29622 24.265 7.53305 23.9119 7.76773 23.5502C7.89906 23.3478 8.03685 23.1325 8.1811 22.9043C8.4696 22.4457 8.71719 22.0367 8.98201 21.5781C9.30281 21.0269 9.63652 20.4219 10.0607 19.6576C10.8336 18.2668 10.9391 18.0127 11.0403 17.7695C11.1049 17.6144 11.1673 17.468 11.4278 16.9836C11.4644 16.9147 11.656 16.5509 11.8153 16.0428C12.0349 15.3344 12.0802 15.0653 11.8907 14.9641V14.962Z",
    fill: "url(#paint7_linear_16376_57035)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2948 10.6671C13.3518 10.131 12.0729 10.6046 11.4357 11.7263C10.7984 12.8459 11.046 14.1893 11.989 14.7254C12.932 15.2615 14.2109 14.7879 14.8481 13.6662C15.4854 12.5445 15.2378 11.2031 14.2948 10.6671ZM12.2925 14.1915C11.5971 13.7975 11.4141 12.8071 11.8835 11.9804C12.3528 11.1536 13.298 10.8048 13.9934 11.1988C14.6888 11.5928 14.8718 12.5832 14.4025 13.41C13.9331 14.2367 12.988 14.5855 12.2925 14.1915Z",
    fill: "url(#paint8_linear_16376_57035)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05177 6.04908L3.31545 5.99956L3.0291 5.98019L2.63726 4.95752L2.21097 5.96727L1.17969 5.99526L1.95261 6.69713L1.85572 7.07821L1.68994 7.71334L2.59205 7.17724L3.47907 7.74563L3.22933 6.73588L4.05177 6.04908Z",
    fill: "url(#paint9_linear_16376_57035)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45935 2.79115L7.91997 2.68566L7.32359 2.6469L6.50115 0.506836L5.61197 2.61892L3.45898 2.6792L5.07372 4.14323L4.86704 4.93983L4.52256 6.26822L6.40857 5.14867L8.26445 6.33712L7.74127 4.22504L9.45935 2.79115Z",
    fill: "url(#paint10_linear_16376_57035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16376_57035",
    x1: 4.42773,
    y1: 15.0358,
    x2: 19.4814,
    y2: 15.0358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16376_57035",
    x1: 7.40234,
    y1: 22.9686,
    x2: 13.7558,
    y2: 22.9686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16376_57035",
    x1: 3.59766,
    y1: 20.4445,
    x2: 8.13615,
    y2: 20.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16376_57035",
    x1: 2.54492,
    y1: 25.4978,
    x2: 11.891,
    y2: 25.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16376_57035",
    x1: 4.93026e-9,
    y1: 13.5865,
    x2: 7.99403,
    y2: 13.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16376_57035",
    x1: 13.6953,
    y1: 20.4206,
    x2: 19.9997,
    y2: 20.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16376_57035",
    x1: 10.5664,
    y1: 7.71306,
    x2: 19.9912,
    y2: 7.71306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16376_57035",
    x1: 6.125,
    y1: 20.1694,
    x2: 12.0097,
    y2: 20.1694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16376_57035",
    x1: 11.082,
    y1: 12.8462,
    x2: 15.2018,
    y2: 12.8462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16376_57035",
    x1: 1.17969,
    y1: 6.44451,
    x2: 4.05177,
    y2: 6.44451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16376_57035",
    x1: 3.45898,
    y1: 3.61632,
    x2: 9.45935,
    y2: 3.61632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGradient);
export default __webpack_public_path__ + "static/media/product-gradient.470c37d7707e7f20cdc7bb578b2679ad.svg";
export { ForwardRef as ReactComponent };